import { instance } from '@/services/avik-api-gateway'
import { VehicleTypePeriod } from '@/types/vehicle-type-period'
import { AxiosResponse } from 'axios'

export function updateVehicleTypePeriod(
  body: VehicleTypePeriod
): Promise<AxiosResponse<VehicleTypePeriod>> {
  return instance.put(`/vehicle-type-period/${body.uuid}`, body)
}
